import React, {useEffect, useState} from 'react';
import { createRoot } from 'react-dom/client';
import './styles.css';
import App from './App';
import ReactModal from 'react-modal';
import { Analytics } from "@vercel/analytics/react"
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';


ReactModal.setAppElement('#root');


function Overlay() {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const [isContactModalOpen, setIsContactModalOpen] = useState(false);

    const openContactModal = () => {
        setIsContactModalOpen(true);
        setIsMenuOpen(false);
    };

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    useEffect(() => {
        const closeMenuOnResize = () => {
            if (isMenuOpen) {
                setIsMenuOpen(false);
            }
        };
        window.addEventListener('resize', closeMenuOnResize);
        return () => {
            window.removeEventListener('resize', closeMenuOnResize);
        };
    }, [isMenuOpen]);

    return (
        <div style={{ position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', pointerEvents: 'none'}}>
            {/* Hamburger Menu */}
            <div className="hamburger-menu" onClick={toggleMenu} style={{ position: 'absolute', top: 20, left: 20, cursor: 'pointer', zIndex: 1, pointerEvents: 'all', }}>
                <div className="hamburger-line" style={{ width: '30px', height: '3px', backgroundColor: 'black', margin: '5px 0' }}></div>
                <div className="hamburger-line" style={{ width: '30px', height: '3px', backgroundColor: 'black', margin: '5px 0' }}></div>
                <div className="hamburger-line" style={{ width: '30px', height: '3px', backgroundColor: 'black', margin: '5px 0' }}></div>
            </div>

            <ReactModal
                isOpen={isContactModalOpen}
                onRequestClose={() => setIsContactModalOpen(false)}
                contentLabel="Contact Modal"
                className="modal-content-contact"
                overlayClassName="modal-overlay"
            >
                <div>
                    <center><h2 className="modal-header">Contact</h2></center>
                    <button onClick={() => setIsContactModalOpen(false)} className="modal-close-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="30px" height="30px" viewBox="0 0 24 24"
                             fill="none">
                            <path
                                d="M9 9L11.9999 11.9999M11.9999 11.9999L14.9999 14.9999M11.9999 11.9999L9 14.9999M11.9999 11.9999L14.9999 9M12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12C21 16.9706 16.9706 21 12 21Z"
                                stroke="#000000" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                        </svg>
                    </button>
                    <div className="contact-content">
                        <p>Feel free to email me at:</p>
                        <a href="mailto:mail.hdhillon@gmail.com" className="contact-email-link">
                            mail.hdhillon@gmail.com
                        </a>
                    </div>
                </div>
            </ReactModal>

            {/* Menu Items */}
            {isMenuOpen && (
                <div className="menu-items" style={{
                    position: 'absolute',
                    top: 60,
                    left: 20,
                    backgroundColor: 'white',
                    padding: '10px',
                    borderRadius: '5px',
                    pointerEvents: 'all'
                }}>
                    <div onClick={openContactModal}
                         style={{display: 'block', margin: '10px 0', cursor: 'pointer'}} className="overlay-text-item">Contact
                    </div>
                </div>
            )}

            {/* Static Overlay Text */}
            <div className="overlay-text" id="cube_title"
                 style={{position: 'absolute', bottom: 40, left: 40, pointerEvents: 'all'}}>
                🔲 Cube Digital Technologies
            </div>
            <div className="overlay-text" style={{
                position: 'absolute',
                top: 40,
                left: 40,
                fontFamily: 'EarlyGameBoy',
                lineHeight: '1.6em',
                whiteSpace: 'pre',
                pointerEvents: 'all'
            }}>
                <div onClick={() => setIsContactModalOpen(true)} className="overlay-text-item">Contact</div>
            </div>
        </div>
    );
}

function MainLayout() {
    return (
        <>
            <App/>
            <Overlay/>
            <Analytics />
        </>
    );
}

createRoot(document.getElementById('root')).render(
    <React.StrictMode>
        <Router>
            <Routes>
                <Route path="/" element={<MainLayout/>} />
            </Routes>
        </Router>
    </React.StrictMode>
);
